import { Button } from "@/ui/button";
import { useGetBotDefaultSlippage } from "@/api/bot/bot-get-default-slippage";
import { useToken } from "@/pages/token-v2/hooks/use-token";

import { FC } from "react";
import { formatDecimalStringFloat } from "@/utils/currency";
import GradientBorderRadius from "@/ui/gradient-border-radius";

const SlippageToggleInputV2: FC<{
  isAuto: boolean;
  value: string;
  onAutoChange: () => void;
  onValueChange: (v: string) => void;
}> = ({ isAuto, value, onAutoChange, onValueChange }) => {
  const { data: defaultSlippage } = useGetBotDefaultSlippage();

  const token = useToken();

  const chain = (
    token?.pair?.networkId === 1 ? "ethereum" : "solana"
  ) as string;

  const defaultValue =
    chain === "ethereum"
      ? defaultSlippage?.ethereumSlippage?.toString()
      : defaultSlippage?.solanaSlippage?.toString();

  return (
    <div className="flex flex-col gap-[0.3125rem] mt-[0.938rem]">
      <span className="text-xs font-semibold">Slippage</span>
      <div className="flex gap-[0.3125rem] h-[1.875rem]">
        <Button
          radius="normal"
          height="h-full"
          active={isAuto}
          title="Auto"
          onClick={() => onAutoChange()}
          className="text-xs flex-1"
        />
        <GradientBorderRadius
          gradient="default-border"
          hover="r-100"
          className="focus-within:before:bg-gradient-100 flex-1"
        >
          <input
            className="w-full h-full outline-none rounded-[0.3125rem] text-xs bg-transparent font-normal text-center"
            value={isAuto ? (defaultValue ? `${defaultValue}%` : "") : value}
            placeholder={defaultValue ? `${defaultValue}%` : ""}
            onChange={(e) => {
              let newValue = e.target.value;
              newValue = newValue.replace("%", "");

              if (newValue === "") {
                onValueChange("");
                return;
              }

              if (Number(newValue) > 100) {
                onValueChange("100%");
                return;
              }
              if (Number(newValue) < 0) {
                onValueChange("0%");
                return;
              }

              const formattedValue = formatDecimalStringFloat(
                newValue,
                true,
                false
              );

              onValueChange(`${formattedValue}%`);
            }}
          />
        </GradientBorderRadius>
      </div>
    </div>
  );
};

export default SlippageToggleInputV2;
